import { IGoal } from "@gtmhub/goals/models";
import { IMetric } from "@gtmhub/okrs/metrics";
import { StateService } from "@uirouter/angularjs";
import { IScope } from "angular";
import { PlanningSessionService } from "../services/planningSessionService";

interface IInspectParamsService {
  statName: string;
  planningSessionId: string;
  tags?: string;
}

export interface IInspectStatisticsCtrlScope extends IScope {
  indicators: any;
  type: string;
  params: IInspectParamsService;
  goals: IGoal[];
  metrics: IMetric[];
}

// this controller controls the main screen of the insights module.
export class InspectStatisticsCtrl {
  public static $inject = ["$scope", "$state", "$stateParams", "PlanningSessionService"];

  constructor(
    private $scope: IInspectStatisticsCtrlScope,
    private $stateService: StateService,
    private $stateParams: IInspectParamsService,
    private planningSessionService: PlanningSessionService
  ) {
    this.$scope.indicators = {};
    this.dispatch();
  }

  private dispatch = () => {
    this.$scope.params = { ...this.$stateParams };
    this.$scope.type = this.$stateParams.statName;
    switch (this.$stateParams.statName) {
      case "goals-hit":
        this.goalsHit();
        break;
      case "metrics-in-danger":
        this.badMetrics();
        break;
      case "metrics-going-well":
        this.goodMetrics();
        break;
      case "metrics-hit":
        this.metricsHit();
        break;
      case "manual-metrics":
        this.manualMetrics();
        break;
      case "dynamic-metrics":
        this.dynamicMetrics();
        break;
      default:
        this.$stateService.go("^.^");
    }
  };

  private goalsHit = () => {
    this.$scope.indicators.loading = true;
    this.planningSessionService.getGoalsHit(this.$stateParams.planningSessionId, this.$stateParams.tags).then((goals) => {
      this.$scope.goals = goals;
      this.$scope.indicators.loading = false;
    });
  };

  private badMetrics = () => {
    this.$scope.indicators.loading = true;
    this.planningSessionService.getBadMetrics(this.$stateParams.planningSessionId, this.$stateParams.tags).then((metrics) => {
      this.$scope.metrics = metrics;
      this.$scope.indicators.loading = false;
    });
  };

  private goodMetrics = () => {
    this.$scope.indicators.loading = true;
    this.planningSessionService.getGoodMetrics(this.$stateParams.planningSessionId, this.$stateParams.tags).then((metrics) => {
      this.$scope.metrics = metrics;
      this.$scope.indicators.loading = false;
    });
  };

  private metricsHit = () => {
    this.$scope.indicators.loading = true;
    this.planningSessionService.getMetricsHit(this.$stateParams.planningSessionId, this.$stateParams.tags).then((metrics) => {
      this.$scope.metrics = metrics;
      this.$scope.indicators.loading = false;
    });
  };

  private manualMetrics = () => {
    this.$scope.indicators.loading = true;
    this.planningSessionService.getManualMetrics(this.$stateParams.planningSessionId, this.$stateParams.tags).then((metrics) => {
      this.$scope.metrics = metrics;
      this.$scope.indicators.loading = false;
    });
  };

  private dynamicMetrics = () => {
    this.$scope.indicators.loading = true;
    this.planningSessionService.getDynamicMetrics(this.$stateParams.planningSessionId, this.$stateParams.tags).then((metrics) => {
      this.$scope.metrics = metrics;
      this.$scope.indicators.loading = false;
    });
  };
}
